import React from 'react';
import PropTypes from 'prop-types';
import ConnectedLungHelp from './ConnectedLungHelp';

function LungHelpRouting({ match }) {
  return <ConnectedLungHelp />;
}

LungHelpRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default LungHelpRouting;
